import { render, staticRenderFns } from "./CartOfferDetailPopin.vue?vue&type=template&id=36410dd1&scoped=true"
import script from "./CartOfferDetailPopin.vue?vue&type=script&lang=js"
export * from "./CartOfferDetailPopin.vue?vue&type=script&lang=js"
import style0 from "./CartOfferDetailPopin.vue?vue&type=style&index=0&id=36410dd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36410dd1",
  null
  
)

export default component.exports